import { Typography } from 'modules/Typography';
import { useTabManager } from '../hooks/useTabManager';
import { useTabProps } from '../hooks/useTabProps';
import { TabBadge, TabContainer } from './styled';
export function Tab(props) {
    const { children, id, disabled, className, badgeValue } = props;
    const { tabProps } = useTabProps(id);
    const { activeTab, stretch } = useTabManager();
    const isActive = id === activeTab;
    return (<TabContainer {...tabProps} type="button" $stretch={stretch} $isActive={isActive} disabled={disabled} className={className}>
      <Typography $fontSize="small" $lineHeight="neutralized">
        {children}
      </Typography>
      {badgeValue !== undefined && (<TabBadge $isActive={isActive}>
          <Typography $fontSize="tiny" $lineHeight="neutralized">
            {badgeValue}
          </Typography>
        </TabBadge>)}
    </TabContainer>);
}
